import { FlexBox, ImageThumbnail } from '@airship-platform/jam-web/components';
import {
  PriceSection,
  ProposalTemplateTag,
} from '@airship-platform/airship-proposal';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { ProposalTemplateOption } from '../../../data-access/proposalTemplate';
import OptionsSelector from './OptionsSelector';

type ProposalTemplateOptionCardProps = {
  proposalTemplateTags: ProposalTemplateTag[];
  proposalTemplateOption: ProposalTemplateOption;
};

const ProposalTemplateOptionCard: React.FC<ProposalTemplateOptionCardProps> = ({
  proposalTemplateTags,
  proposalTemplateOption,
}) => {
  const totalPrice = proposalTemplateOption.products
    .flatMap((p) =>
      p.prices
        .filter((d) => d.priceType === p.defaultPriceType)
        .map((price) => price.value * p.quantity)
    )
    .reduce((prev, curr) => prev + curr, 0);

  const itemsCount =
    proposalTemplateOption.products.length +
    proposalTemplateOption.modifiers.length;

  const imageUrl = proposalTemplateOption.products
    .flatMap((m) => m.images)
    .map((i) => i.url)
    .find(Boolean);

  return (
    <FlexBox
      key={proposalTemplateOption.proposalTemplateOptionId}
      flexDirection={['column', 'column', 'row']}
      gap={2}
      width={'100%'}
    >
      <FlexBox gap={2} width={'100%'}>
        <ImageThumbnail imageUrl={imageUrl} alt={proposalTemplateOption.name} />

        <FlexBox flexDirection={'column'} gap={2} flex={1}>
          <FlexBox
            flexDirection={['column', 'row']}
            alignItems={['inherit', 'flex-start']}
            gap={2}
          >
            <FlexBox flexDirection={'column'} gap={1} width={'100%'}>
              <Typography variant="h6">
                {proposalTemplateOption.name}
              </Typography>
              <Typography variant="body1" component={'div'}>
                <PriceSection prefix={''} value={totalPrice} />
                &nbsp; ({itemsCount} items)
              </Typography>
            </FlexBox>
          </FlexBox>

          <FlexBox flexWrap={'wrap'} gap={1}>
            {proposalTemplateTags.map((tag) => (
              <Chip
                key={tag.proposalTemplateTagId}
                label={tag.name}
                color="softBlue"
              />
            ))}
          </FlexBox>
        </FlexBox>
      </FlexBox>
      <OptionsSelector proposalTemplateOption={proposalTemplateOption} />
    </FlexBox>
  );
};

export default ProposalTemplateOptionCard;
